import { useCallback, useMemo } from 'react';

// Use the custom notification sound file
const NOTIFICATION_SOUND_URL = '/notification_online.mp3';
const NOTIFICATION_SOUND_VOLUME = 0.7;

export function useNotificationSound() {
  const playSoftDing = useCallback(async () => {
    if (typeof window === 'undefined') return;
    if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;

    try {
      // Create a new Audio instance each time to avoid state conflicts
      const audio = new Audio(NOTIFICATION_SOUND_URL);
      audio.volume = NOTIFICATION_SOUND_VOLUME;
      
      // Reset to start before playing
      audio.currentTime = 0;
      
      await audio.play();
    } catch (error) {
      // Browsers may block audio until an explicit user gesture.
      console.warn('Notification sound was blocked:', error);
    }
  }, []);

  return useMemo(() => ({ playSoftDing }), [playSoftDing]);
}
